import actions from './actions';
import { createReducer } from '../../../../../helpers/reducer';

const SEARCH_MAX_RESULTSCOUNT = 100;
const initState = {
  blockedTalents: null,
  loading: false,
  saving: false,
  total: 0,
  talents: [],
  talentsFilter: '',
  filteredTalents: [],
  isModalShown: false,
  addBlockedTalentsForm: null,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal } = payload;
  const blockedTalents = data;

  return {
    ...state,
    blockedTalents: blockedTalents || [],
    total,
    filteredTotal,
    loading: false,
    saving: false,
  };
}

function onLoadFormDataSuccess(state, { payload }) {
  const talents = payload.data.workers;

  return {
    ...state,
    talents,
    talentsFilter: '',
    filteredTalents: [],
  };
}

function onClearStore() {
  return { ...initState };
}

function onShowModal(state) {
  return {
    ...state,
    addBlockedTalentsForm: {
      talents: [],
    },
    isModalShown: true,
  };
}

function onSave(state) {
  return {
    ...state,
    saving: true,
  };
}

function onSaveSuccess(state) {
  return {
    ...state,
    isModalShown: false,
    addBlockedTalentsForm: null,
    saving: false,
  };
}

function onCancel(state) {
  return {
    ...state,
    isModalShown: false,
    addBlockedTalentsForm: null,
    saving: false,
  };
}

function onFilterTalents(state, { payload }) {
  const { filter } = payload;
  const filteredTalents = state.talents
    .filter(talent => talent.name.toLowerCase().includes(filter.toLowerCase()))
    .slice(0, SEARCH_MAX_RESULTSCOUNT);

  return {
    ...state,
    talentsFilter: filter,
    filteredTalents,
  };
}

function onChangeSelectedTalents(state, { payload }) {
  const { talents } = payload;

  return {
    ...state,
    addBlockedTalentsForm: {
      talents,
    },
    filteredTalents: [],
    talentsFilter: '',
  };
}

function onUnblockTalent(state) {
  return {
    ...state,
    loading: true,
  };
}

function onUnblockTalentSuccess(state, { payload }) {
  const { id } = payload;
  const blockedTalents = state.blockedTalents.filter(talent => talent.id !== id);

  return {
    ...state,
    blockedTalents,
    loading: false,
  };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.LOAD_FORM_DATA_SUCCESS]: onLoadFormDataSuccess,
  [actions.SHOW_MODAL]: onShowModal,
  [actions.SAVE]: onSave,
  [actions.SAVE_SUCCESS]: onSaveSuccess,
  [actions.CANCEL]: onCancel,
  [actions.FILTER_TALENTS]: onFilterTalents,
  [actions.CHANGE_SELECTED_TALENTS]: onChangeSelectedTalents,
  [actions.UNBLOCK_TALENT]: onUnblockTalent,
  [actions.UNBLOCK_TALENT_SUCCESS]: onUnblockTalentSuccess,
});
